export default "__VITE_ASSET__Dwe1iKFI__"